/**
 * @shakkerai/services request 的TypeScript版本
 */
import axios, { type AxiosRequestConfig } from 'axios';
import { config } from '@shakkerai/config';
import { getUsertokenFromCookie, getCookieWebid } from '@shakkerai/util-cookie';

// 创建 axios 实例
const axiosInstance = axios.create({
  timeout: 10000,
  headers: {
    'accept-language': config.language,
  },
});

// 请求拦截器
axiosInstance.interceptors.request.use((config) => {
  const token = getUsertokenFromCookie();
  if (token) {
    config.headers.token = token;
  }
  return config;
});

function getUrl(url: string = '') {
  return url.startsWith('http') ? url : config.apiHost + url;
}

/**
 * 没有完美, 只有合适
 * */
export async function request<R = any, P = any>(url: string): Promise<R>;
export async function request<R = any, P = any>(url: string, data: P): Promise<R>;
export async function request<R = any, P = any>(options: AxiosRequestConfig<P>): Promise<R>;
export async function request<R = any, P = any>(urlOrOptions: string | AxiosRequestConfig<P>, data?: P): Promise<R> {
  const isFirstParamUrl = typeof urlOrOptions === 'string';
  const mergedOptions = isFirstParamUrl ? {} : urlOrOptions ?? {};
  const url = isFirstParamUrl ? getUrl(urlOrOptions) : getUrl(mergedOptions.url);
  const method = mergedOptions?.method ?? 'post'; // 默认post, 这点和axios不一致
  const isPost = method === 'post';

  const requestStart = Date.now();
  let response;
  try {
    response = await axiosInstance.request(
      Object.assign(mergedOptions, {
        url,
        method,
        // post请求需要带上cid
        [isPost ? 'data' : 'params']: isPost
          ? {
              ...data,
              cid: getCookieWebid(),
            }
          : data,
      }),
    );
  } catch (error) {
    // console.log('[DEBUG] ~ error:', error);
  }
  const time = `${Date.now() - requestStart}ms`;

  // response error
  if (!response || response.status !== 200 || !response.data) {
    return {
      code: -1,
      time,
      msg: 'request fail',
    } as R;
  }

  return {
    ...response.data,
    time,
  } as R;
}

// get简化写法
request.get = async <R = any, P = any>(url: string, data?: P) => {
  return request<R, P>(Object.assign({ url, method: 'get' }, data ? { params: data } : {}));
};
